var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoalIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H38C43.5229 0 48 4.47715 48 10V38C48 43.5229 43.5228 48 38 48H10C4.47715 48 0 43.5228 0 38V10Z",
    fill: "#DC6803"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 26H28.51M15 17V31C15 32.1046 15.8954 33 17 33H31C32.1046 33 33 32.1046 33 31V21C33 19.8954 32.1046 19 31 19L17 19C15.8954 19 15 18.1046 15 17ZM15 17C15 15.8954 15.8954 15 17 15H29M29 26C29 26.2761 28.7761 26.5 28.5 26.5C28.2239 26.5 28 26.2761 28 26C28 25.7239 28.2239 25.5 28.5 25.5C28.7761 25.5 29 25.7239 29 26Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalIcon2);
export default __webpack_public_path__ + "static/media/Goal_icon_2.b9ae9957b763226e32a7eaf9ff7bb406.svg";
export { ForwardRef as ReactComponent };